// Endereços do Pokémon FireRed (EUA) 1.0, tirados de pokefirered.sym
// (branch `symbols` do pret/pokefirered). As nossas ROMs (decompilação traduzida)
// mudam alguns endereços de dados; nesse caso o servidor manda os certos junto com a
// ROM (ver scripts/rom-info.mjs) e o app usa `useSymbols`.

export const FIRERED_US_10 = {
  // IWRAM
  gMain: 0x030030f0,
  gSaveBlock1Ptr: 0x03005008,
  gSaveBlock2Ptr: 0x0300500c,
  gPokemonStoragePtr: 0x03005010,
  gFieldCamera: 0x03005050,
  sHorizontalCameraPan: 0x03000e98,
  sVerticalCameraPan: 0x03000e9a,

  // EWRAM
  gPlayerPartyCount: 0x02024029,
  gPlayerParty: 0x02024284,
  gObjectEvents: 0x02036e38,
  gPlayerAvatar: 0x02037078,

  // ROM (funções; ponteiros guardados com o bit Thumb ligado, +1)
  CB2_Overworld: 0x080565b4,
  BattleMainCB2: 0x08011100,

  // ROM (dados): sprites do jogador no mapa (16x32, 4bpp) e a paleta deles
  gObjectEventPal_Player: 0x0835b968,
  sPicTable_RedNormal: 0x083a00a0,
  sPicTable_GreenNormal: 0x083a0188,

  // ROM (dados): Pokémon — foto de frente (LZ77) e ícone animado do menu (32x32, 2 quadros)
  gMonFrontPicTable: 0x082350ac,
  gMonPaletteTable: 0x0823730c,
  gMonIconTable: 0x083d37a0,
  gMonIconPaletteIndices: 0x083d3e80,
  gMonIconPaletteTable: 0x083d4038,
};

export type SymbolName = keyof typeof FIRERED_US_10;
export type FireRedSymbols = Record<SymbolName, number>;

let active: FireRedSymbols = FIRERED_US_10;

/** Endereços da ROM em uso. */
export const activeSymbols = (): FireRedSymbols => active;

/** Troca os endereços (ROM nossa); o que não vier fica igual ao do FireRed EUA 1.0. */
export function useSymbols(overrides: Partial<FireRedSymbols> | null): void {
  active = { ...FIRERED_US_10, ...(overrides ?? {}) };
}
